import React, { useState, useEffect, useRef } from "react";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import DeleteModal from "./Assets/DeleteModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Category from "./category";

const Services = ({ isSidebarCollapsed }) => {
  const fileInputRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({ name: "",category: "", description: "" ,features:"" ,price:"" ,isNew:"" });
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [preview, setPreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://viklang.serverscripts.in/api/v1/treatments/view", {
        method: "GET",
         headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
          },
      });
        if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }

      const result = await response.json();
      if (result.success) setCategories(result.data);
      else toast.error(result.message || "Failed to fetch categories");
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch categories");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Treatment name is required!");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");

      const form = new FormData();
      form.append("name", formData.name);
      form.append("category", formData.category);
      form.append("description", formData.description);
      form.append("features", formData.features);
      form.append("price", formData.price);
      form.append("isNew", formData.isNew);
      if (file) form.append("image", file);
      if (editId) form.append("id", editId);

      const url = editId
        ? "https://viklang.serverscripts.in/api/v1/treatments/edit"
        : "https://viklang.serverscripts.in/api/v1/treatments/add";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, 
        },
        body: form,
      });
      if (response.status === 401) {
              toast.error("Session expired, please log in again");
              localStorage.removeItem("authToken");
              navigate('/login');
              return;
            }
      const data = await response.json();
      

      if (data.success) {
        toast.success(data.message);
        setFormData({ name: "",category: "", description: "" ,features:"" ,price:"" ,isNew:""});
        setEditId(null);
        setFile(null);
        setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
        fetchData();
         if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
      } else {
        toast.error(data.message || "Failed to save services");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong!");
    }
  };


  const handleEdit = (id) => {
    const catToEdit = categories.find((c) => c.id === id);
    if (catToEdit) {
      setFormData({
        id: catToEdit.id,
        name: catToEdit.name,
        description: catToEdit.description || "",
        features: catToEdit.features || "",
        category: catToEdit.category || "",
        price: catToEdit.price || "",
        isNew: catToEdit.isNew || "",
      });
      setPreview(catToEdit.img || catToEdit.image_url || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ name: "",category: "", description: "" ,features:"" ,price:"" ,isNew:""});
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`https://viklang.serverscripts.in/api/v1/treatments/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: itemToDelete }),
      });
      if (response.status === 401) {
              toast.error("Session expired, please log in again");
              localStorage.removeItem("authToken");
              navigate('/login');
              return;
            }
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setCategories((prev) => prev.filter((cat) => cat.id !== itemToDelete));
      } else {
        toast.error(data.message || "Failed to delete services");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete services");
    } finally {
      setDeleteModalShow(false);
      setItemToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const loadFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);
    }
  };

  return (
<div className="role-settings-container">
      <div className="bg-white p-[1vw] role-settings-form-container">
        <div className="text-[20px] font-bold border-b border-gray-300 pb-[2px] text-gray-600">
          <h1>{editId ? "Update Treatment" : "Add Treatment"}</h1>
        </div>

        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Name *
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              type="text"
              placeholder="Enter Treatment Name"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Category *
            </label>
            <input
              name="category"
              value={formData.category}
              onChange={(e) =>
                setFormData({ ...formData, category: e.target.value })
              }
              type="text"
              placeholder="Enter Category Name"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Description *
            </label>
            <input
              name="description"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              type="text"
              placeholder="Enter Description"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Price *
            </label>
            <input
              name="price"
              value={formData.price}
              onChange={(e) =>
                setFormData({ ...formData, price: e.target.value })
              }
              type="text"
              placeholder="Please enter price."
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Features (separated by commas)*
            </label>
            <input
              name="features"
              value={formData.features}
              onChange={(e) =>
                setFormData({ ...formData, features: e.target.value })
              }
              type="text"
              placeholder="Please enter the key points, separated by commas."
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Is New *
            </label>

            <select
              name="isNew"
              value={formData.isNew}
              onChange={(e) =>
                setFormData({ ...formData, isNew: Number(e.target.value) })
              }
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            >
              <option value="">Select an option</option>
              <option value={1}>Yes</option>
              <option value={0}>No</option>
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Upload Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={loadFile}
              ref={fileInputRef}
              className="block w-full"
            />
            {preview && (
              <img
                src={preview}
                alt="Preview"
                className="mt-2 w-32 h-32 object-cover  rounded-lg "
              />
            )}
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setFormData({ name: "",category: "", description: "" ,features:"" ,price:"" ,isNew:""});
                  setEditId(null);
                  setFile(null);
                  setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                }}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Treatment List</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        <th className="px-4 py-2 text-left">#</th>
                        <th className="px-4 py-2 text-left">Image</th>
                        <th className="px-4 py-2 text-left">name</th>
                        <th className="px-4 py-2 text-left">Description</th>
                        <th className="px-4 py-2 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {categories.length > 0 ? (
                        categories.map((cat, index) => (
                          <tr className="grid grid-cols-5" key={cat.id}>
                            <td className="px-4 py-2">{index + 1}</td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              <img
                                src={cat.img}
                                alt={cat.name}
                                className="h-16 w-16 object-cover "
                              />
                              
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                             
                              <div>
                                <div className="font-semibold text-gray-800">
                                  {cat.name}
                                </div>
                               
                              </div>
                            </td>
                            
                            <td className="px-4 py-2">{truncateText(cat.description, 100)}</td>
                            <td className="px-4 py-2">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(cat.id)}
                                  className="text-blue-500 hover:text-blue-700 text-[20px]"
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(cat.id)}
                                  className="text-red-500 hover:text-red-700 text-[20px]"
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="p-2 text-center">
                            No categories found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>

      {deleteModalShow && (
        <DeleteModal
          itemName={
            categories.find((p) => p.id === itemToDelete)?.name ||
            "Unknown"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Services;

const truncateText = (text, maxLength = 100) => {
  if (!text) return "—";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};